// extracted by mini-css-extract-plugin
export default {"root":"Header_root__AgbL1","container":"Header_container__bqvWG"};